import React from 'react';
import { TrendingUp, ArrowRight } from 'lucide-react';

const InvestorRelations = () => {
  return (
    <section 
      className="py-20 md:py-28 bg-[#1e3a5f]"
      data-testid="investor-relations-section"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <TrendingUp className="w-5 h-5 text-[#C9A227]" />
              <span className="text-white/40 text-xs tracking-[0.3em] uppercase">
                Investment Opportunities
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-light text-white mb-6" style={{ lineHeight: 1.1 }}>
              Investor<br />
              <span className="text-[#C9A227]">Relations</span>
            </h2>
            
            {/* Gold divider */}
            <div className="w-16 h-[2px] bg-[#C9A227] mb-6" />
            
            <p className="text-white/50 text-lg leading-relaxed mb-8 max-w-lg">
              Explore investment opportunities with Sebastian Alliance Group. 
              We build and operate fintech infrastructure powering digital commerce, 
              payment integrations, and financial ecosystems across the Caribbean and beyond.
            </p>

            <a
              href="/investor"
              className="inline-flex items-center gap-3 px-8 py-4 bg-[#C9A227] text-black font-medium text-sm tracking-wide uppercase hover:bg-white transition-colors group"
              data-testid="investor-cta-button"
            >
              Access Investor Portal
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          {/* Right - Stats */}
          <div className="grid grid-cols-2 gap-10">
            {[
              { value: '15+', label: 'Integrated Platforms & Solutions' },
              { value: 'Global', label: 'Banking & Payment Integrations' },
              { value: '3+', label: 'Regional Markets (Caribbean, US, LATAM)' },
              { value: '2010', label: 'Founded' }
            ].map((stat, idx) => (
              <div key={idx} className="text-center lg:text-left">
                <div className="text-3xl md:text-4xl font-light text-white mb-2">
                  {stat.value}
                </div>
                <div className="text-white/40 text-sm">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestorRelations;
